import Logo from "../../assets/images/Logo.svg";
import ActiveHome from "../../assets/images/sidebar/active/Home.svg";
import InactiveHome from "../../assets/images/sidebar/inactive/Home.svg";
import ActiveReports from "../../assets/images/sidebar/active/Reports.svg";
import InactiveReports from "../../assets/images/sidebar/inactive/Reports.svg";
import ActiveUsers from "../../assets/images/sidebar/active/Users.svg";
import InactiveUsers from "../../assets/images/sidebar/inactive/Users.svg";
import ActiveSettings from "../../assets/images/sidebar/active/Settings.svg";
import InactiveSettings from "../../assets/images/sidebar/inactive/Settings.svg";
import ActiveNotification from "../../assets/images/sidebar/active/Notification.svg";
import InactiveNotification from "../../assets/images/sidebar/inactive/Notification.svg";
import InactiveMusic from "../../assets/images/sidebar/inactive/Headphones.svg";
import ActiveMusic from "../../assets/images/sidebar/active/Headphones.svg";
import InactiveCalendar from "../../assets/images/sidebar/inactive/Calendar.svg";
import ActiveCalendar from "../../assets/images/sidebar/active/Calendar.svg";
import { Link, useNavigate } from "react-router-dom";
import { Fragment, useContext, useState } from "react";
import LogoutIcon from "../../assets/images/Logout.svg";
import ToolTip from "../ToolTip/ToolTip";
import { getCurrentDimension, isInRole, removeTokens } from "../../helpers/HelperFunctions";
import ApiService from "../../services/ApiService";
import Loading from "../Loading/Loading";
import { User, FirebaseUser } from "../../store/Store";
import { firebaseSignOut } from "../../helpers/FirebaseFunctions";
import FileProgress from "../FileProgress/FileProgress";
import { INotification } from "../../helpers/Interfaces";

import "./SideBar.scss";

export default function SideBar(props: { selectedIndex: number }) {

  let screenWidth = getCurrentDimension().width

  const apiService = new ApiService();

  const [loading, setLoading] = useState(false);

  const [user] = useContext(User);
  const [firebaseUser] = useContext(FirebaseUser);

  const navigate = useNavigate();

  function getNewNotificationsCount() {
    let newNotifications: INotification[] = firebaseUser?.notifications?.filter((notification: INotification) => {
      return !notification?.read
    });

    return newNotifications?.length;
  }

  function handleLogout() {

    setLoading(true);

    apiService.logout().finally(async () => {
      removeTokens();
      await firebaseSignOut();
      navigate("/login");
      setLoading(false);
    });
  }

  return (
    <div className="side-bar-container">
      <img className="logo" src={Logo} alt={"Logo"} />
      <div className="nav-link-container">
        <div>
          {screenWidth > 425 && (props.selectedIndex === 0
            ? (<Link className="nav-link active" to={"/dashboard/home"}>
              <ToolTip title="Home" showArrow={true} position={"right-start"} toolTipRootCSS="tool-tip-one">
                <img className="img" src={ActiveHome} alt={"Home"} />
              </ToolTip>
            </Link>)
            : (<Link className="nav-link" to={"/dashboard/home"}>
              <ToolTip title="Home" showArrow={true} position={"right-start"} toolTipRootCSS="tool-tip-one">
                <img className="img" src={InactiveHome} alt={"Home"} />
              </ToolTip>
            </Link>)
          )
          }

          {screenWidth > 425 && (props.selectedIndex === 1
            ? (<Link className="nav-link active" to={"/dashboard/appointments"}>
              <ToolTip title="Appointments" showArrow={true} position={"right-start"} toolTipRootCSS="tool-tip-one">
                <img className="img" src={ActiveCalendar} alt={"Appointments"} />
              </ToolTip>
            </Link>)
            : (<Link className="nav-link" to={"/dashboard/appointments"}>
              <ToolTip title="Appointments" showArrow={true} position={"right-start"} toolTipRootCSS="tool-tip-one">
                <img className="img" src={InactiveCalendar} alt={"Appointments"} />
              </ToolTip>
            </Link>))
          }

          {props.selectedIndex === 2
            ? (<Link className="nav-link active" to={"/dashboard/reports"}>
              <ToolTip title="Reports" showArrow={true} position={"right-start"} toolTipRootCSS="tool-tip-one">
                <img className="img" src={ActiveReports} alt={"Reports"} />
              </ToolTip>
            </Link>)
            : (<Link className="nav-link" to={"/dashboard/reports"}>
              <ToolTip title="Reports" showArrow={true} position={"right-start"} toolTipRootCSS="tool-tip-one">
                <img className="img" src={InactiveReports} alt={"Reports"} />
              </ToolTip>
            </Link>)
          }

          {props.selectedIndex === 3
            ? (<Link className="nav-link active" to={"/dashboard/audio"}>
              <ToolTip title="Audio" showArrow={true} position={"right-start"} toolTipRootCSS="tool-tip-one">
                <img className="img" src={ActiveMusic} alt={"Audio"} />
              </ToolTip>
            </Link>)
            : (<Link className="nav-link" to={"/dashboard/audio"}>
              <ToolTip title="Audio" showArrow={true} position={"right-start"} toolTipRootCSS="tool-tip-one">
                <img className="img" src={InactiveMusic} alt={"Audio"} />
              </ToolTip>
            </Link>)
          }

          {isInRole(user?.roles, "Manager")
            ? (props.selectedIndex === 4
              ? (<Link className="nav-link active" to={"/dashboard/users"}>
                <ToolTip title="Users" showArrow={true} position={"right-start"} toolTipRootCSS="tool-tip-one">
                  <img className="img" src={ActiveUsers} alt={"Users"} />
                </ToolTip>
              </Link>)
              : (<Link className="nav-link" to={"/dashboard/users"}>
                <ToolTip title="Users" showArrow={true} position={"right-start"} toolTipRootCSS="tool-tip-one">
                  <img className="img" src={InactiveUsers} alt={"Users"} />
                </ToolTip>
              </Link>))
            : (<Fragment />)
          }

          {isInRole(user?.roles, "Manager")
            ? (props.selectedIndex === 5
              ?
              (<Link className="nav-link active" to={"/dashboard/settings"}>
                <ToolTip title="Settings" showArrow={true} position={"right-start"} toolTipRootCSS="tool-tip-one">
                  <img className="img" src={ActiveSettings} alt={"Settings"} />
                </ToolTip>
              </Link>)
              : (<Link className="nav-link" to={"/dashboard/settings"}>
                <ToolTip title="Settings" showArrow={true} position={"right-start"} toolTipRootCSS="tool-tip-one">
                  <img className="img" src={InactiveSettings} alt={"Settings"} />
                </ToolTip>
              </Link>))
            : (<Fragment />)
          }
        </div>

        {props.selectedIndex === 6
          ? (<Link className={getNewNotificationsCount() > 0 ? "notification-link-wrapper flex-end active"
            : "notification-link-wrapper center active"} to={"/dashboard/notifications"}>
            <ToolTip title="Notifications" showArrow={true} position={"right-start"} toolTipRootCSS="tool-tip-one">
              <img className="notification-img" src={ActiveNotification} alt={"Notifications"} />
            </ToolTip>
            {getNewNotificationsCount() > 0
              ? (<span className="count">{getNewNotificationsCount()}</span>)
              : (<Fragment />)
            }
          </Link>)
          : (<Link className={getNewNotificationsCount() > 0 ? "notification-link-wrapper flex-end"
            : "notification-link-wrapper center"} to={"/dashboard/notifications"}>
            <ToolTip title="Notifications" showArrow={true} position={"right-start"} toolTipRootCSS="tool-tip-one">
              <img className="notification-img" src={InactiveNotification} alt={"Notifications"} />
            </ToolTip>
            {getNewNotificationsCount() > 0
              ? (<span className="count">{getNewNotificationsCount()}</span>)
              : (<Fragment />)
            }
          </Link>)
        }
      </div>
      <div className="profile">
        <span className="profile-text">Profile</span>
        <Link className="name" to={"/dashboard/settings"}>
          <ToolTip title="Profile" showArrow={true} position={"right-start"} toolTipRootCSS="tool-tip-one">
            <FileProgress name={user?.firstName + " " + user?.lastName} imageUrl={user?.profileImageUrl} style={"profile-img"} />
          </ToolTip>
        </Link>
        <Link className="logout" to="#" onClick={() => { handleLogout() }}>
          {loading
            ? (<Loading color="white" />)
            : (<ToolTip title="Logout" showArrow={true} position={"right-start"} toolTipRootCSS="tool-tip-one">
              <img className="logout-img" src={LogoutIcon} alt={"Logout"} />
            </ToolTip>)
          }
        </Link>
      </div>
    </div>
  );
}
